// extracted by mini-css-extract-plugin
export default {"container":"nZ-z","list":"oZ-z"};